(function () {
  'use strict';

  var EVENT_NAME = 'fullotProductSupport:open';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function arrowIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  }

  function backIcon() {
    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>';
  }

  function playIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 7l8 5-8 5V7z"/></svg>';
  }

  function mediaMarkup(product) {
    if (product.image) {
      return '<span class="product-support__product-media"><img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.name) + '" loading="lazy"></span>';
    }
    return '<span class="product-support__product-media product-support__product-media--empty" aria-hidden="true"></span>';
  }

  function faqMarkup(faqs, openId) {
    var visibleLimit = 5;
    var items = faqs.map(function (faq, faqIndex) {
      var shouldOpen = faq.id === openId || (!openId && faqIndex === 0);
      var isExtra = faqIndex >= visibleLimit;
      return [
        '<details class="product-support__faq" data-faq-id="', escapeHtml(faq.id), '"', isExtra ? ' data-faq-extra hidden' : '', shouldOpen ? ' open' : '', '>',
          '<summary><span class="product-support__faq-question"><span class="product-support__faq-number">', faqIndex + 1, '</span><span>', escapeHtml(faq.q), '</span></span></summary>',
          '<div class="product-support__answer">', escapeHtml(faq.a), '</div>',
        '</details>'
      ].join('');
    }).join('');
    var toggle = faqs.length > visibleLimit
      ? '<div class="product-support__faq-toggle-wrap"><button class="product-support__faq-toggle" type="button" data-faq-toggle aria-expanded="false">Show more</button></div>'
      : '';
    return '<div class="product-support__faq-list" data-faq-list>' + items + '</div>' + toggle;
  }

  function manualsMarkup(manuals) {
    if (!manuals || !manuals.length) {
      return '<div class="product-support__empty">No manuals available.</div>';
    }
    return '<div class="product-support__resource-list">' + manuals.map(function (manual) {
      return [
        '<a class="product-support__resource" href="', escapeHtml(manual.url), '" target="_blank" rel="noopener" aria-label="View or download ', escapeHtml(manual.title), ' PDF">',
          '<span class="product-support__resource-badge" aria-hidden="true">PDF</span>',
          '<span class="product-support__resource-copy">',
            '<strong class="product-support__resource-title">', escapeHtml(manual.title), '</strong>',
            '<span class="product-support__resource-meta">PDF · User Manual</span>',
          '</span>',
          '<span class="product-support__resource-action">View / Download PDF ', arrowIcon(), '</span>',
        '</a>'
      ].join('');
    }).join('') + '</div>';
  }

  function videosMarkup(videos) {
    if (!videos || !videos.length) {
      return '<div class="product-support__empty">No support videos available.</div>';
    }
    return '<div class="product-support__video-list">' + videos.map(function (video) {
      var cover = video.cover
        ? '<img class="product-support__video-cover" src="' + escapeHtml(video.cover) + '" alt="" loading="lazy">'
        : '<span class="product-support__video-cover"></span>';
      return [
        '<button class="product-support__video" type="button" data-video-url="', escapeHtml(video.url), '" data-video-title="', escapeHtml(video.title), '" data-video-cover="', escapeHtml(video.cover || ''), '" aria-label="Play ', escapeHtml(video.title), '">',
          '<span class="product-support__video-cover-wrap">', cover,
            '<span class="product-support__video-play">', playIcon(), '</span>',
          '</span>',
          '<span class="product-support__video-title">', escapeHtml(video.title), '</span>',
        '</button>'
      ].join('');
    }).join('') + '</div>';
  }

  function initializeSection(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var data = window.FullotProductSupportData || [];
    var mode = 'product';
    var categoryId = data[0] ? data[0].id : '';
    var productCode = '';
    var pendingFaqId = '';
    var modeNav = root.querySelector('[data-product-support-mode]');
    var categoryNav = root.querySelector('[data-product-support-categories]');
    var main = root.querySelector('[data-product-support-main]');
    var videoModal = root.querySelector('[data-video-modal]');
    var videoPlayer = root.querySelector('[data-video-player]');
    var videoModalTitle = root.querySelector('[data-video-modal-title]');
    var videoOpener = null;

    function closeVideo() {
      if (!videoModal || videoModal.hidden) return;
      videoModal.hidden = true;
      document.body.classList.remove('product-support-video-open');
      if (videoPlayer) {
        videoPlayer.pause();
        videoPlayer.removeAttribute('src');
        videoPlayer.removeAttribute('poster');
        videoPlayer.load();
      }
      if (videoOpener) videoOpener.focus();
      videoOpener = null;
    }

    function openVideo(button) {
      if (!videoModal || !videoPlayer || !button) return;
      videoOpener = button;
      videoPlayer.src = button.dataset.videoUrl;
      if (button.dataset.videoCover) videoPlayer.poster = button.dataset.videoCover;
      videoModalTitle.textContent = button.dataset.videoTitle || 'Support Video';
      videoModal.hidden = false;
      document.body.classList.add('product-support-video-open');
      videoPlayer.load();
      var playPromise = videoPlayer.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      var closeButton = videoModal.querySelector('[data-video-close]');
      if (closeButton) closeButton.focus();
    }

    function getCategory() {
      return data.filter(function (category) { return category.id === categoryId; })[0] || data[0];
    }

    function renderNavigation() {
      modeNav.innerHTML = [
        '<button class="product-support__mode-button', mode === 'product' ? ' is-active' : '', '" type="button" role="tab" aria-selected="', mode === 'product', '" data-mode="product">Product Support</button>',
        '<button class="product-support__mode-button', mode === 'general' ? ' is-active' : '', '" type="button" role="tab" aria-selected="', mode === 'general', '" data-mode="general">General FAQs</button>'
      ].join('');

      categoryNav.hidden = data.length <= 1;
      categoryNav.innerHTML = data.length <= 1 ? '' : data.map(function (category) {
        return '<button class="product-support__category-button' + (category.id === categoryId ? ' is-active' : '') + '" type="button" aria-pressed="' + (category.id === categoryId) + '" data-category="' + escapeHtml(category.id) + '">' + escapeHtml(category.title) + '</button>';
      }).join('');
    }

    function renderProductList() {
      var category = getCategory();
      if (!category || !category.products.length) {
        main.innerHTML = '<div class="product-support__empty">Product support content is coming soon.</div>';
        return;
      }
      main.innerHTML = '<div class="product-support__grid">' + category.products.map(function (product) {
        return [
          '<button class="product-support__product-card" type="button" data-product-code="', escapeHtml(product.code), '">',
            mediaMarkup(product),
            '<span class="product-support__product-copy">',
              '<span class="product-support__product-name">', escapeHtml(product.name), '</span>',
              '<span class="product-support__product-link">View product support ', arrowIcon(), '</span>',
            '</span>',
          '</button>'
        ].join('');
      }).join('') + '</div>';
    }

    function renderProductDetail() {
      var category = getCategory();
      var product = category && category.products.filter(function (item) { return item.code === productCode; })[0];
      if (!product) {
        productCode = '';
        renderProductList();
        return;
      }

      main.innerHTML = [
        '<button class="product-support__back" type="button" data-product-support-back>', backIcon(), 'Back to ', escapeHtml(category.title), '</button>',
        '<div class="product-support__detail">',
          '<div class="product-support__detail-head">',
            mediaMarkup(product),
            '<div class="product-support__product-copy">',
              '<p class="product-support__eyebrow">', escapeHtml(category.title), '</p>',
              '<h3 class="product-support__detail-title">', escapeHtml(product.name), '</h3>',
            '</div>',
          '</div>',
          '<section class="product-support__panel" aria-labelledby="manuals-', escapeHtml(product.code), '">',
            '<h4 class="product-support__panel-title" id="manuals-', escapeHtml(product.code), '">User Manuals</h4>',
            manualsMarkup(product.manuals),
          '</section>',
          '<section class="product-support__panel" aria-labelledby="videos-', escapeHtml(product.code), '">',
            '<h4 class="product-support__panel-title" id="videos-', escapeHtml(product.code), '">How-to Videos</h4>',
            videosMarkup(product.videos),
          '</section>',
          '<section class="product-support__panel" aria-labelledby="faqs-', escapeHtml(product.code), '">',
            '<h4 class="product-support__panel-title" id="faqs-', escapeHtml(product.code), '">Product FAQs</h4>',
            faqMarkup(product.faqs, pendingFaqId),
          '</section>',
        '</div>'
      ].join('');
    }

    function renderGeneralFaqs() {
      var category = getCategory();
      if (!category) return;
      main.innerHTML = [
        '<div class="product-support__general-head">',
          '<h3 class="product-support__general-title">', escapeHtml(category.title), '</h3>',
        '</div>',
        '<div class="product-support__detail">',
          '<section class="product-support__panel">',
            '<h4 class="product-support__panel-title">User Manuals</h4>',
            manualsMarkup(category.manuals),
          '</section>',
          '<section class="product-support__panel">',
            '<h4 class="product-support__panel-title">Support Videos</h4>',
            videosMarkup(category.videos),
          '</section>',
        '<section class="product-support__panel" aria-label="', escapeHtml(category.title), ' general FAQs">',
          '<h4 class="product-support__panel-title">Frequently Asked Questions</h4>',
          faqMarkup(category.generalFaqs, pendingFaqId),
          '</section>',
        '</div>'
      ].join('');
    }

    function render() {
      renderNavigation();
      if (mode === 'general') {
        productCode = '';
        renderGeneralFaqs();
      } else if (productCode) {
        renderProductDetail();
      } else {
        renderProductList();
      }
    }

    function revealFaq() {
      if (!pendingFaqId) return;
      var details = main.querySelector('[data-faq-id="' + pendingFaqId.replace(/"/g, '\\"') + '"]');
      if (details) {
        if (details.hidden) {
          var panel = details.closest('.product-support__panel');
          var toggle = panel && panel.querySelector('[data-faq-toggle]');
          Array.prototype.forEach.call(panel.querySelectorAll('[data-faq-extra]'), function (item) {
            item.hidden = false;
          });
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
            toggle.textContent = 'Show less';
          }
        }
        details.open = true;
        window.setTimeout(function () {
          details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 80);
      }
      pendingFaqId = '';
    }

    modeNav.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mode]');
      if (!button) return;
      mode = button.dataset.mode;
      productCode = '';
      pendingFaqId = '';
      render();
    });

    categoryNav.addEventListener('click', function (event) {
      var button = event.target.closest('[data-category]');
      if (!button) return;
      categoryId = button.dataset.category;
      productCode = '';
      pendingFaqId = '';
      render();
    });

    main.addEventListener('click', function (event) {
      var productButton = event.target.closest('[data-product-code]');
      var backButton = event.target.closest('[data-product-support-back]');
      var faqToggle = event.target.closest('[data-faq-toggle]');
      var videoButton = event.target.closest('[data-video-url]');
      if (videoButton) {
        openVideo(videoButton);
      } else if (faqToggle) {
        var faqPanel = faqToggle.closest('.product-support__panel');
        var extraFaqs = faqPanel ? faqPanel.querySelectorAll('[data-faq-extra]') : [];
        var isExpanded = faqToggle.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(extraFaqs, function (item) {
          item.hidden = isExpanded;
          if (isExpanded) item.open = false;
        });
        faqToggle.setAttribute('aria-expanded', String(!isExpanded));
        faqToggle.textContent = isExpanded ? 'Show more' : 'Show less';
      } else if (productButton) {
        productCode = productButton.dataset.productCode;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (backButton) {
        productCode = '';
        pendingFaqId = '';
        render();
      }
    });

    if (videoModal) {
      videoModal.addEventListener('click', function (event) {
        if (event.target === videoModal || event.target.closest('[data-video-close]')) closeVideo();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !videoModal.hidden) closeVideo();
      });
    }

    document.addEventListener(EVENT_NAME, function (event) {
      var detail = event.detail || {};
      categoryId = detail.categoryId || categoryId;
      mode = detail.kind === 'general' ? 'general' : 'product';
      productCode = detail.productCode || '';
      pendingFaqId = detail.faqId || '';
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      revealFaq();
    });

    render();
  }

  function initializeSearch() {
    var data = window.FullotProductSupportData || [];
    var form = document.querySelector('[data-product-support-search]');
    if (!form || form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    var input = form.querySelector('input[type="search"]');
    var results = document.querySelector('[data-product-support-search-results]');
    if (!input || !results) return;

    var index = [];
    var activeIndex = -1;

    data.forEach(function (category) {
      (category.generalFaqs || []).forEach(function (faq) {
        index.push({ categoryId: category.id, categoryTitle: category.title, kind: 'general', productCode: '', faqId: faq.id, question: faq.q, searchable: normalize(category.title + ' ' + faq.q + ' ' + faq.a) });
      });
      (category.products || []).forEach(function (product) {
        (product.faqs || []).forEach(function (faq) {
          index.push({ categoryId: category.id, categoryTitle: category.title, kind: 'product', productCode: product.code, faqId: faq.id, question: faq.q, searchable: normalize(category.title + ' ' + product.code + ' ' + product.name + ' ' + faq.q + ' ' + faq.a) });
        });
      });
    });

    function matchesFor(query) {
      var tokens = normalize(query).split(' ').filter(Boolean);
      if (!tokens.length) return [];
      return index.filter(function (item) {
        return tokens.every(function (token) { return item.searchable.indexOf(token) !== -1; });
      }).slice(0, 8);
    }

    function closeResults() {
      results.classList.remove('is-open');
      results.innerHTML = '';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function renderResults() {
      var matches = matchesFor(input.value);
      activeIndex = -1;
      if (!normalize(input.value)) {
        closeResults();
        return;
      }
      if (!matches.length) {
        results.innerHTML = '<div class="contact-banner__search-empty">No matching FAQ found. Try different keywords.</div>';
      } else {
        results.innerHTML = matches.map(function (item) {
          var meta = item.kind === 'general' ? 'General FAQs · ' + item.categoryTitle : 'Product Support · ' + item.categoryTitle;
          return [
            '<button class="contact-banner__search-result" type="button" data-category="', escapeHtml(item.categoryId), '" data-kind="', item.kind, '" data-product="', escapeHtml(item.productCode), '" data-faq="', escapeHtml(item.faqId), '">',
              '<span class="contact-banner__search-result-question">', escapeHtml(item.question), '</span>',
              '<span class="contact-banner__search-result-meta">', escapeHtml(meta), '</span>',
            '</button>'
          ].join('');
        }).join('');
      }
      results.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function openResult(button) {
      if (!button) return;
      document.dispatchEvent(new CustomEvent(EVENT_NAME, {
        detail: { categoryId: button.dataset.category, kind: button.dataset.kind, productCode: button.dataset.product, faqId: button.dataset.faq }
      }));
      input.value = '';
      closeResults();
    }

    function setActive(nextIndex) {
      var buttons = Array.prototype.slice.call(results.querySelectorAll('.contact-banner__search-result'));
      if (!buttons.length) return;
      activeIndex = (nextIndex + buttons.length) % buttons.length;
      buttons.forEach(function (button, buttonIndex) { button.classList.toggle('is-active', buttonIndex === activeIndex); });
      buttons[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', renderResults);
    input.addEventListener('focus', function () { if (normalize(input.value)) renderResults(); });
    input.addEventListener('keydown', function (event) {
      var buttons = results.querySelectorAll('.contact-banner__search-result');
      if (event.key === 'ArrowDown' && buttons.length) {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp' && buttons.length) {
        event.preventDefault();
        setActive(activeIndex < 0 ? buttons.length - 1 : activeIndex - 1);
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    form.addEventListener('submit', function (event) {
      var buttons = results.querySelectorAll('.contact-banner__search-result');
      var first = buttons[activeIndex >= 0 ? activeIndex : 0];
      if (first) {
        event.preventDefault();
        openResult(first);
      }
    });

    results.addEventListener('click', function (event) { openResult(event.target.closest('.contact-banner__search-result')); });
    document.addEventListener('click', function (event) { if (!event.target.closest('.contact-banner__search-wrap')) closeResults(); });
  }

  function initialize() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-support]'), initializeSection);
    initializeSearch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();

  document.addEventListener('shopify:section:load', initialize);
})();
